import { TextField } from "@mui/material";
import { FC } from "react";
import { useTranslation } from "react-i18next";

import { IAddressSearchBounds } from "@ryde/shared";

import { BOUNDS_EDGES } from "./bounds-block.const";

interface IBoundsBlockEdgesProps {
  bounds: IAddressSearchBounds | undefined;
  isDisabled: boolean;
  onEdgeChange: (edge: keyof IAddressSearchBounds, value: number) => void;
}

/**
 * The four edges as numbers, so a bound can be typed exactly rather than only dragged.
 *
 * Blank while there is no rectangle at all — that is the "search worldwide" state, not a zero.
 * A typed edge moves the rectangle on the map as it is typed; the map draws from the same draft.
 */
export const BoundsBlockEdges: FC<IBoundsBlockEdgesProps> = ({
  bounds,
  isDisabled,
  onEdgeChange,
}) => {
  const { t } = useTranslation();

  return (
    <div className="edges">
      {BOUNDS_EDGES.map(edge => (
        <TextField
          key={edge}
          size="small"
          type="number"
          disabled={isDisabled}
          label={t(`systemParam.addressSearchBounds.${edge}`)}
          value={bounds ? bounds[edge] : ""}
          slotProps={{
            htmlInput: { "data-e2e": `bounds-edge-${edge}`, step: "0.01" },
          }}
          onChange={event => onEdgeChange(edge, Number(event.target.value))}
        />
      ))}
    </div>
  );
};
